import {
  createContext,
  useCallback,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { PropTypes } from "prop-types";
import { useLooksProducts } from "./LooksProductsContext";
import { getPreselectedProduct } from "../../utils/product";
import { usePreviousBackInStock } from "../backInStock/BackInStockContext";

export const SelectedLooksProductContext = createContext({});

export const SelectedLooksProductProvider = ({ children }) => {
  const { looksProducts } = useLooksProducts();
  const [selectedLooksProductId, setSelectedLooksProductId] = useState(null);
  const { previousBackInStockProductId } = usePreviousBackInStock();

  const selectedLooksProduct =
    looksProducts?.find(({ id }) => id === selectedLooksProductId) ??
    looksProducts?.[1];

  const handleLooksCarouselClick = useCallback((productId) => {
    setSelectedLooksProductId(productId);
  }, []);

  useEffect(() => {
    const preSelectedLooksProduct = getPreselectedProduct(
      looksProducts,
      previousBackInStockProductId,
    );
    if (preSelectedLooksProduct) {
      setSelectedLooksProductId(preSelectedLooksProduct.id);
    }
  }, [looksProducts, previousBackInStockProductId]);

  const value = useMemo(
    () => ({
      selectedLooksProduct,
      setSelectedLooksProduct: handleLooksCarouselClick,
    }),
    [selectedLooksProduct, handleLooksCarouselClick],
  );

  return (
    <SelectedLooksProductContext.Provider value={value}>
      {children}
    </SelectedLooksProductContext.Provider>
  );
};

export const useSelectedLooksProduct = () =>
  useContext(SelectedLooksProductContext);

SelectedLooksProductProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
